import React, {Component} from "react";
import {GoogleMap, withGoogleMap, Polyline} from "react-google-maps";
import DrawingManager from "react-google-maps/lib/drawing/DrawingManager";

import Button from 'material-ui/Button';

import tsl from './../../../tsl';

/*
 * Add <script src="https://maps.googleapis.com/maps/api/js"></script> to your HTML to provide google.maps reference
 */

/*
 * https://developers.google.com/maps/documentation/javascript/examples/drawing-tools
 *
 * Note: requires the Google Maps drawing API library in your script src
 *
 * Credits: thanks @idolize for the contribution!
 */
const DrawingGoogleMap = withGoogleMap(props => (
    <GoogleMap
        defaultZoom={props.defaultZoom}
        defaultCenter={props.defaultCenter}
        ref={props.onMapLoaded}
    >
        {!props.drawable ? null : 
            <DrawingManager
                defaultDrawingMode={google.maps.drawing.OverlayType.POLYLINE}
                onPolylineComplete={props.onPolylineComplete}
                defaultOptions={{
                    drawingControl: true,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: [
                            //google.maps.drawing.OverlayType.CIRCLE,
                            //google.maps.drawing.OverlayType.POLYGON,
                            google.maps.drawing.OverlayType.POLYLINE,
                            //google.maps.drawing.OverlayType.RECTANGLE,
                        ],
                    },
                    polylineOptions: {
                        strokeColor: 'rgba(0,0,230,0.9)',
                        strokeWeight: 10,
                        editable: true,
                    },
                    /*circleOptions: {
                        fillColor: '#ff0000',
                        fillOpacity: 0.2,
                        strokeWeight: 3,
                        clickable: false,
                        editable: true,
                        zIndex: 1,
                    },
                    rectangleOptions: {
                        fillColor: '#ff0000',
                        fillOpacity: 0.2,
                        strokeWeight: 3,
                        clickable: false,
                        editable: true,
                        zIndex: 1,
                    },*/
                }}
            />
        }
        
        {props.polyline
            ? <Polyline
                /* this key will force creation of a new component each time the path is changed */
                key={props.polyline.map(p => p.lat + ',' + p.lng).join(';')}
                ref={props.onPolylineCreated}
                path={props.polyline}
                options={{strokeColor: "rgba(0,0,230,0.9)", strokeWeight: 10, editable: !!props.drawable}}
              />
            : null
        }

        {props.children}
    </GoogleMap>
));

export default class EditationFlightRoute extends Component {

    state = {
        polyline: null,
        defaultZoom: 6,
        defaultCenter: {        // Italian restaurant in Zurich, where MyAirSeat deal was made
            lat: 47.377750,
            lng: 8.543806
        }
    }

    transformRoutePointsToPath(route_points) {
        var polylinePath = [];

        // sort points by position
        route_points.sort((a, b) => {
            return (a.position < b.position) ? -1 : 1;
        });
        //console.log('sorted points', route_points);

        for (let i in route_points) {
            polylinePath.push({
                lat: parseFloat(route_points[i].gps_lat),
                lng: parseFloat(route_points[i].gps_long)
            });    
        }
        //console.log('polyline path', polylinePath);            

        return polylinePath;
    }

    onPolylineComplete = (polyline) => {

        // throw it away, because we will render the polyline ourselves after propagation
        // so we can attach events to it
        polyline.setMap(null);

        this.propagate(polyline);
    };

    onPolylineCreated = (polyline) => {

        if (polyline) {
          google.maps.event.addListener(polyline.getPath(), 'set_at', () => {
            this.propagate(polyline);
          });

          google.maps.event.addListener(polyline.getPath(), 'insert_at', () => {
            this.propagate(polyline);
          });

          google.maps.event.addListener(polyline.getPath(), 'remove_at', () => {
            this.propagate(polyline);
          });
        }
    };

    propagate = (polyline) => {

        let gpoints = polyline ? polyline.getPath().getArray() : [];

        let resultObj = {
          ...this.props.route,
          points: gpoints.map((point, i) => ({
            gps_lat: point.lat(),
            gps_long: point.lng(),
            position: 1 + i,  // positions = index + 1
          }))
        };

        this.props.onChange(resultObj)
    };

    clean = () => {
        this.propagate(null);
    };

    getDefaultCenter = () => {
        return new google.maps.LatLng(this.state.defaultCenter.lat, this.state.defaultCenter.lng);
    }

    calculateCenterAndBounds = (props) => {
        if (props.route) {
            const points = props.route.points.slice();

            const bounds = new google.maps.LatLngBounds();
            points.map(p => bounds.extend({
                lat: parseFloat(p.gps_lat),
                lng: parseFloat(p.gps_long)
            }));

            this.setState({
                defaultCenter: {
                    lat: bounds.getCenter().lat(),
                    lng: bounds.getCenter().lng()
                },
                bounds,
            });
        }
    }

    componentWillMount() {
        this.calculateCenterAndBounds(this.props);
    }

    componentWillReceiveProps = (nextProps) => {
        this.calculateCenterAndBounds(nextProps);
    }

    mapLoaded = (map) => {
        if (map && this.state.bounds) {
            map.fitBounds(this.state.bounds);

            this.props.onMapLoaded && this.props.onMapLoaded(map);
        }
    }

    render() {
        const polylinePath = (this.props.route && this.props.route.points)
            ? this.transformRoutePointsToPath(this.props.route.points)
            : null;

        const defaultCenter = this.getDefaultCenter();

        const drawable = this.props.editable != undefined ? this.props.editable : true;

        return (!this.props.displayed ? null :

                <div style={{width: "100%"}}>
                    <DrawingGoogleMap
                        drawable={drawable}
                        onPolylineComplete={this.onPolylineComplete}
                        onPolylineCreated={this.onPolylineCreated}
                        containerElement={
                            <div className="embed-responsive embed-responsive-21by9"/>
                        }
                        mapElement={<div className="embed-responsive-item"/>}
                        polyline={polylinePath ? polylinePath : null}
                        defaultCenter={defaultCenter}
                        defaultZoom={this.state.defaultZoom}
                        onMapLoaded={this.mapLoaded}
                    >
                      {this.props.children}
                    </DrawingGoogleMap>
                    <br />
                    {this.props.editable && this.props.route && this.props.route.points.length
                        ? <Button onClick={this.clean} style={{textColor: "red"}}>{tsl('offers.edit.route.clean')}</Button>
                        : ''
                    }
                </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/used/offers/routes/EditationFlightRoute.js